var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-content"},[_c('div',{staticClass:"mt-s"},[(_vm.version == 4)?_c('div',[_c('Version4',{attrs:{"data":_vm.data}})],1):_vm._e(),(_vm.version == 5)?_c('div',[_c('Version5',{attrs:{"data":_vm.data}})],1):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }